var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6955 4.21944H13.7864V3.05278H12.6955V4.21944ZM12.6955 7.54444H13.7864V6.37778H12.6955V7.54444ZM12.6955 10.85H13.7864V9.68333H12.6955V10.85ZM11.6773 14V12.8333H15.6591V1.16667H8.47727V3.34444L7.38636 2.52778V0H16.75V14H11.6773ZM0.75 14V6.41667L5.67727 2.64444L10.5864 6.41667V14H6.64091V10.0917H4.71364V14H0.75ZM1.84091 12.8333H3.62273V8.925H7.73182V12.8333H9.49545V7.01944L5.67727 4.08333L1.84091 7.02765V12.8333Z",
    fill: "#DF8D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSector);
export default __webpack_public_path__ + "static/media/sector.7bd0ef6abc1040b5a12d674f5af779d8.svg";
export { ForwardRef as ReactComponent };